import { useFetch } from '@reveni-io/reveni-ui'

import inventoryServices from '@/inventory/services/services'

import { transformResponseCustomsRequirements } from './transformers'

const useCustomsRequirements = ({ storeId }) => {
  const { data, loading } = useFetch(inventoryServices.getCustomsRequirements, {
    doInitialRequest: true,
    params: { storeId },
    transformResponse: transformResponseCustomsRequirements,
  })

  return {
    customsRequirements: data,
    loadingCustomsRequirements: loading,
  }
}

export default useCustomsRequirements
